import React, {Component, useEffect, useRef, useState} from 'react';
import {Button, CircularProgress, TextField} from '@mui/material';
import {connect} from 'react-redux';
import {useAuth} from 'react-oidc-context';
import {Redirect} from 'react-router-dom';

import {loginRequest} from '../../actions/login';
import {GAEventTracker} from '../../lib/googleAnalytics';
import {addGroupListInLocal, getCookie, getFromLocalStorage, NewLocalStorage, routeToLogin, setCookie, validateLoginRequest} from '../../lib/utils';
import {isAdminPanelRole, derivePrimaryRole, effectiveRoles} from '../../auth/roles';
import {decodeJwtPayload} from '../../auth/tokenUtils';
import {adoptExistingSession, clearSignedOutFlag, wasSignedOutRemotely} from '../../auth/sessionSync';
import Api from '../../api';
import {GET_CONTACT_GROUP_URL} from '../../lib/constant';

const isOidcEnabled = () => {
  const clientId = process.env.REACT_APP_OIDC_CLIENT_ID;
  return clientId && clientId !== 'REPLACE_WITH_ZITADEL_CLIENT_ID';
};

class Login extends Component {
  constructor(){
    super();
    this.state = {
      userIdMobile : '',
      password : '',
      btnDisabled : false,
      error: null
    };
    this.loginHandler = this.loginHandler.bind(this);
  }
  componentWillMount(){
    if(getCookie("userToken")){
      let localStorageData = getFromLocalStorage();
      if(isAdminPanelRole(localStorageData.role)){
        this.props.history.push("/admin-panel");
      } else{
        this.props.history.push("/dashboard");
      }
    }
  }
  async componentDidUpdate(){
    let {loginResponse} = this.props;
    if(loginResponse && loginResponse.success){
      setCookie("userToken",loginResponse.data.token, 30);
      setCookie("userId",loginResponse.data.userId, 30);
      const res = await Api.get(GET_CONTACT_GROUP_URL);
      if (res?.data?.success && res.data?.data) {
        addGroupListInLocal(res.data)
      } else {
        console.log(res)
      }
      if(isAdminPanelRole(loginResponse.data.role)){
        this.props.history.push("/admin-panel");
      } else{
        this.props.history.push("/dashboard");
      }
    }
  }
  componentWillReceiveProps(nextProps){
    if(this.state.btnDisabled === true && nextProps.loginResponse){
      this.setState({btnDisabled : false});
    }
  }
  loginHandler(){
    let {userIdMobile,password} = this.state;
    const params = {userIdMobile : userIdMobile.toLowerCase(),password}
    const validation = validateLoginRequest(params)
    if (validation.isValidated) {
      this.setState({btnDisabled : true, error: null});
      GAEventTracker({category : 'Sign-in',action:'Click'});
      this.props.loginRequest(params);
    } else {
      this.setState({error: validation.errorJson})
    }
  }
  enterLoginHandler(eKey){
    if(eKey === 'Enter'){
      this.loginHandler();
    }
  }
  render() {
    const {loginResponse} = this.props;
    let {userIdMobile,password,btnDisabled, error} = this.state;
    const isMobile = window.isMobile();
    return (
      <div>
        <div className="login container-lg" style={{display: 'flex', alignItems: 'center'}}>
          {!isMobile &&
            <div style={{flex: 0.5, display: 'flex', justifyContent: 'center'}}>
              <img src={process.env.REACT_APP_LOGIN_ILL} style={{maxWidth: '80%'}} alt='login'></img>
            </div>
          }
          <div style={{flex: isMobile ? 1 : '0.5', marginLeft: 'auto'}}>
            <p style={{fontSize: 16, marginBottom: 20, color: '#616161'}}>LOGIN</p>
            <h4 style={{fontSize: 36}}>Welcome</h4>
            <p style={{fontSize: 14, marginTop: 8, color: '#616161'}}>Login to send and manage SMS</p>
            <div>
              <div style={{display: 'flex', gap: 16, flexDirection: 'column', paddingTop: 16}}>
                <TextField
                  label="Enter your user name"
                  placeholder='Username'
                  fullWidth={true}
                  value={userIdMobile}
                  size='small'
                  onKeyPress={e => this.enterLoginHandler(e.key)}
                  onChange={e => {this.setState({userIdMobile : e.target.value, error: null})}}
                  error={!!error?.userIdMobile}
                  variant='standard'
                  shrink={!!userIdMobile}
                  helperText={error?.userIdMobile || ''} />
                <TextField
                  label="Enter your password"
                  type="password"
                  placeholder="Password"
                  fullWidth={true}
                  size='small'
                  value={password}
                  onKeyPress={e => this.enterLoginHandler(e.key)}
                  onChange={e => this.setState({password : e.target.value, error: null})}
                  variant='standard'
                  error={!!error?.password}
                  shrink={!!password}
                  helperText={error?.password || ''} />
              </div>
              {
                loginResponse && !loginResponse.success ?
                  <p className="login-error">{loginResponse.message}</p>
                  : null
              }
              <div style={{display: 'flex', gap: 16, paddingTop: 36}}>
                <div>
                  <p style={{display:'inline-block',fontSize:12,verticalAlign:'middle'}}>Don't have an account yet?</p>
                  <a href="https://combirds.com/contact-us/" onClick={e=>{GAEventTracker({category : 'Sign-up', action :'Click'})}}>
                    <Button>Sign Up</Button>
                  </a>
                </div>
                <div style={{marginLeft: 'auto'}}>
                  {
                    btnDisabled ?
                      <CircularProgress size={20} thickness={2} />
                      : null
                  }
                  <Button disabled={btnDisabled} onClick={this.loginHandler.bind(this)} variant='contained' size="large">
                    Login
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
// Login.contextTypes = {
//   router: PropTypes.object.isRequired
// };
function mapStateToProps(state) {
  return {loginResponse: state.loginResponse.loginResponse};
}
const LoginLegacy = connect(mapStateToProps,{loginRequest})(Login);

const LoginWithOidc = (props) => {
  const auth = useAuth();
  const attemptedRef = useRef(false);
  const [signedOut, setSignedOut] = useState(() => wasSignedOutRemotely());

  useEffect(() => {
    const handlePageShow = (event) => {
      if (!event.persisted) {
        return;
      }

      const isAuthenticated = isOidcEnabled()
        ? !!localStorage.getItem(NewLocalStorage)
        : !!getCookie('userToken');

      if (!isAuthenticated) {
        window.location.reload();
      }
    };

    window.addEventListener('pageshow', handlePageShow);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);

  useEffect(() => {
    // signedOut: this tab got here because ANOTHER tab logged out. Auto-
    // redirecting now would race that tab's end_session and log us right back
    // in off the surviving SSO cookie — wait for a deliberate click instead.
    if (signedOut) return;
    // Re-read rather than trusting the mount-time state: the flag can be set
    // after this component mounted (a remote logout sets it, then hard-navs),
    // and the stale false would fire the signinRedirect this guard exists to
    // suppress. See AuthGuard for the same check.
    if (wasSignedOutRemotely()) {
      setSignedOut(true);
      return;
    }
    if (isOidcEnabled() && !auth.isLoading && !auth.isAuthenticated && !auth.activeNavigator && !auth.error && !attemptedRef.current) {
      attemptedRef.current = true;
      auth.signinRedirect().catch((err) => {
        console.error('OIDC signinRedirect failed:', err);
      });
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.activeNavigator, auth.error, signedOut]);

  const signInAgain = async () => {
    clearSignedOutFlag();
    setSignedOut(false);
    attemptedRef.current = true;
    // Another tab may have signed in while this one sat on the card. The
    // shared store is the source of truth — adopt it rather than sending the
    // user through the IdP for a session we already hold.
    if (await adoptExistingSession()) return;
    auth.signinRedirect().catch((err) => {
      console.error('OIDC signinRedirect failed:', err);
    });
  };

  if (signedOut && !auth.isAuthenticated) {
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', gap: 16}}>
        <p>You have been signed out.</p>
        <Button variant="contained" onClick={signInAgain}>Sign in again</Button>
      </div>
    );
  }

  // Already authenticated via OIDC — never show the login page (that's the
  // door to starting a second-account flow at the IdP). Same landing rule as
  // the legacy login: admin-panel roles → /admin-panel, everyone else →
  // /dashboard. Roles come from THIS TAB's token, not localStorage, so the
  // redirect can't follow another tab's identity.
  if (auth.isAuthenticated) {
    const claims = decodeJwtPayload(auth.user?.access_token) || {};
    const role = derivePrimaryRole(effectiveRoles(claims));
    return <Redirect to={isAdminPanelRole(role) ? '/admin-panel' : '/dashboard'} />;
  }

  // Show OIDC error if any. Retry through routeToLogin, not signinRedirect:
  // the error usually means the stored OIDC state is broken, and reusing it
  // just reproduces the same failure. routeToLogin clears it and reloads this
  // page, which then starts a clean signin.
  if (auth.error) {
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', gap: 16}}>
        <p>Login error: {auth.error.message}</p>
        <Button variant="contained" onClick={routeToLogin}>Try again</Button>
      </div>
    );
  }

  // OIDC is configured — show loading while redirecting to Zitadel
  if (isOidcEnabled()) {
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
        <CircularProgress />
      </div>
    );
  }

  // Legacy login form (OIDC not configured)
  return <LoginLegacy {...props} />;
};

export default LoginWithOidc;
